<div class="form-group">
  <label
    *ngIf="appendLabel"
    [class.success]="showSuccess"
    class="input-label select-label"
    >{{ labelName }} <span *ngIf="flagAsRequired">*</span>
  </label>
  <div class="input-group">
    <select
      #selectList
      (change)="valueSelected(selectList.value)"
      [disabled]="value?.disabled"
      [formControlName]="inputName"
      [id]="inputName"
      [name]="inputName"
      class="form-select">
      <option *ngIf="noValueText" value="" disabled hidden>
        {{ noValueText }}
      </option>
      <option
        *ngFor="let item of _selectOptions"
        [ngValue]="item.defaultValue ? item.defaultValue : item.value"
        [class]="getOptionClass(item.optionStyle)">
        <span *ngIf="ellipsisStart">{{
          item.description | textEllipsis: ellipsisStart
        }}</span>
        <span *ngIf="!ellipsisStart">{{
          item.description | textEllipsis
        }}</span>
      </option>
    </select>
    <app-copy-button
      *ngIf="canCopy"
      [copyItem]="getCopyItem()"
      [iconSize]="iconSize"
      [label]="copyLabel">
    </app-copy-button>
    <div *ngIf="showButton" class="ms-2">
      <button
        (click)="clickButton()"
        [disabled]="
          value?.disabled ||
          ((!parentForm.dirty || !parentForm.valid) && useFormForButton)
        "
        class="btn btn-primary"
        type="button">
        {{ buttonName }}
      </button>
    </div>
  </div>
</div>

<ng-container
  *ngIf="
    !hideError && (validationText || value.invalid) && value.touched;
    else label
  ">
  <app-error-label
    *ngIf="value.invalid && value.touched; else label"
    [message]="
      validationText ? validationText : 'This field is invalid'
    "></app-error-label>
</ng-container>
<ng-template #label>
  <app-info-label
    *ngIf="description && displayDescriptionLabel && !displayValueLabel"
    [message]="description"></app-info-label>
  <app-info-label
    *ngIf="value && !displayDescriptionLabel && displayValueLabel"
    [message]="value.value"></app-info-label>
</ng-template>
